import type { TextFieldProps } from "./FormFields.interface";

export default function TextField({
  label,
  value,
  onChange,
  placeholder = "Введите...",
  invalid,
  readOnly = false,
}: TextFieldProps) {
  return (
    <div className={`form-field ${invalid ? "invalid" : ""}`}>
      <label>{label}</label>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readOnly}
      />
    </div>
  );
}
